import React, { useEffect } from "react";
import { DisclosureForm } from "./DisclosureForm";
import { useDisclosures } from "./useDisclosures";
import { MultiStepItemProps } from "@ucl/library";

export interface DisclosureStepProps extends MultiStepItemProps {
  disclosureId: string;
  financialApplicationId: string;
}

export const DisclosureStep: React.FC<DisclosureStepProps> = (props) => {
  const { agreeToDisclosure } = useDisclosures(props.financialApplicationId);

  const handleSubmit = async () => {
    try {
      await agreeToDisclosure(props.disclosureId);
      return true;
    } catch (error) {
      console.error("Failed to agree to disclosure:", error);
      return false;
    }
  };

  useEffect(() => {
    props.registerSubmit?.(handleSubmit);
  }, [props.disclosureId]);

  return (
    <DisclosureForm
      disclosureId={props.disclosureId}
      financialApplicationId={props.financialApplicationId}
    />
  );
};
